import React from 'react'
import DoctorHeader from './DoctorHeader'
import DoctorSideBar from './DoctorSideBar'
import { Link } from 'react-router-dom'
import FeatherIcon from 'feather-icons-react/build/FeatherIcon'
const DoctorChronicManagement = () => {
  return (
    <>
    <DoctorHeader/>
    <DoctorSideBar/>
    <div className='page-wrapper'>
      <div className='content'>
      <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Dashboard </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">Chronic Care Management</li>
                </ul>
              </div>
            </div>
          </div>
      </div>
    </div>
    </>
  )
}

export default DoctorChronicManagement
